import React, { useState } from 'react';
import Icon from '../../../common/Icon';

// These are the <li> response files for the FileValue component
const ResponseFile = ({
  placeholder,
  responseFile,
  handleUpdateFilename,
  handleDestroyFile,
}) => {
  // Hides file extension while editing filename
  const simpleName = (filename) => {
    const extRegExp = /^(.+)\.(\w{1,4})$/gi;
    let match = extRegExp.exec(filename) || [];
    return match.length > 2 ? match[1] : filename;
  };
  // Keep original file extention (or none at all)
  const reapplyFileExtension = (nameWithExt, newName) => {
    const extRegExp = /^(.+)(\.\w{1,4})$/gi;
    let match = extRegExp.exec(nameWithExt) || [];
    let extension = match.length > 2 ? match[2] : null;
    return extension ? newName + extension : simpleName(newName);
  };

  const originalName = simpleName(responseFile.filename);
  const [fileName, setFileName] = useState(originalName);

  return (
    <div className='text-input response-file' key={responseFile.id}>
      <a
        target='_blank'
        href={`/manage/response_files/${responseFile.id}`}
        className='file-dl'
      >
        <i className='fa-solid fa-download'></i>
      </a>
      <input
        type='text'
        value={fileName}
        onChange={(e) => setFileName(e.target.value)}
        onBlur={(e) => {
          if (fileName != originalName) {
            let newName = reapplyFileExtension(responseFile.filename, fileName);
            handleUpdateFilename(e, responseFile.id, newName);
          }
        }}
        placeholder={placeholder}
      />
      <Icon
        className='destroy'
        icon='trash'
        onClick={() => handleDestroyFile(responseFile.id)}
      />
    </div>
  );
};

export default ResponseFile;
